import { StateCreator } from 'zustand';
import { ProposalSlice } from './proposal.types';

export const createProposalSlice: StateCreator<
  ProposalSlice,
  [],
  [],
  ProposalSlice
> = () => ({
  proposal: null,
  loading: true,
});
